@if (canPrint()) {
<div class="pos-relative p-l m-t m-b-8 related-products">
    <!-- transcluded header -->
    <ng-content />

    <div class="pos-absolute top-0 right-0 p-r">
        <button class="m-r-2"
                [ngClass]="'product-prev-' + uid"
                type="button">
            <i class="icon-chevron-left fs-3"
               aria-hidden="true"></i>
            <span class="sr-only">{{'Previous slide' | translate}}</span>
        </button>
        <button [ngClass]="'product-next-' + uid"
                type="button">
            <i class="icon-chevron-right fs-3"
               aria-hidden="true"></i>
            <span class="sr-only">{{'Next slide' | translate}}</span>
        </button>
    </div>

    <carousel class="slides-per-view-auto"
              [class.swiper-overflow-visible]="client.isS || client.isM"
              [style.--carousel-slides-per-view-round]="slidesPerViewRound"
              [style.--carousel-slides-per-view]="slidesPerView"
              [style.--carousel-space-between.px]="spaceBetween"
              [slidesPerView]="slidesPerView"
              [slidesPerGroup]="1"
              [spaceBetween]="spaceBetween"
              [watchSlidesProgress]="true"
              [loop]="loop"
              [freeMode]="true"
              [navigation]="{
                nextEl: '.product-next-' + uid,
                prevEl: '.product-prev-' + uid
            }"
              [speed]="600"
              [allowTouchMove]="client.isTouchy"
              [gtmTrackViewItemList]="gtmTrackViewItemList"
              [gtmTrackViewItemListOff]="client.isCms">
        @for (item of models; track item.id) {
        <ng-template carouselSlide>
            <product [disableCarousel]="true"
                     [listPosition]="$index"
                     [listId]="listId"
                     [listName]="listName"
                     [model]="$any(item)" />
        </ng-template>
        }
    </carousel>
</div>
}